import styled from 'styled-components';
import { Flex } from 'UI';

export const SOperationsWrapper = styled(Flex)`
  background-color: ${({ theme }) => theme.color.grey_brown};
  border-radius: 8px;
  padding: 6px 12px;
`;
